import { useEffect, useState } from 'preact/hooks';
import { t } from '../i18n/index.js';

/** "2 h 15 min" / "12 min". */
function formatLeft(ms: number): string {
  const minutes = Math.max(0, Math.ceil(ms / 60_000));
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h} h ${m} min` : `${m} min`;
}

/**
 * Guest mark and the time left of the visit in the top bar (decision 2026-09-29). When the time is
 * up, `onEnded` re-checks the login (the server has ended the session).
 */
export function GuestBadge(props: { until: number; onEnded: () => void }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(timer);
  }, []);
  const left = props.until - now;
  useEffect(() => {
    if (left > 0) return;
    // A moment later, so that the server has ended the session.
    const timer = setTimeout(props.onEnded, 3000);
    return () => clearTimeout(timer);
  }, [left > 0]);
  return (
    <span class={`guest-badge ${left < 15 * 60_000 ? 'ending' : ''}`} title={t.guest.badgeTitle}>
      {t.guest.badge} · {t.guest.timeLeft(formatLeft(left))}
    </span>
  );
}
